import type {
  FetchWhatsNewAction,
  FetchWhatsNewActionFulfilled,
  FetchWhatsNewActionRejected,
} from "domains/whatsNew/actionTypes";
import { WhatsNewActionType } from "domains/whatsNew/actionTypes";

export const fetchWhatsNew = (): FetchWhatsNewAction => ({
  type: WhatsNewActionType.FETCH,
});

export const fetchWhatsNewSuccess = (
  payload: FetchWhatsNewActionFulfilled["payload"],
): FetchWhatsNewActionFulfilled => ({
  type: WhatsNewActionType.FETCH_FULFILLED,
  payload,
});

export const fetchWhatsNewFailure = (): FetchWhatsNewActionRejected => ({
  type: WhatsNewActionType.FETCH_REJECTED,
});
